import { jsxs as o, jsx as a } from "react/jsx-runtime";
import { PromoBadges as H } from "../../PromoBadges/PromoBadges.js";
import { a as c } from "../../checks-C6AyTTQ0.js";
import { c as d } from "../../clsx-OuTLNxxd.js";
import { HilightedBadge as C } from "./HilightedBadge.js";
const F = "FareCardHeader-module_header__kLIrc",
  z = "FareCardHeader-module_horizontal-header__fFDF6",
  w = "FareCardHeader-module_white-background__zbdza",
  g = "FareCardHeader-module_neutral01-background__BI-nl",
  B = "FareCardHeader-module_hilighted__c0GAo",
  f = "FareCardHeader-module_header-content__jYG34",
  k = "FareCardHeader-module_horizontal-header-content__WxC--",
  N = "FareCardHeader-module_title-wrapper__UXobr",
  v = "FareCardHeader-module_horizontal-title-wrapper__7Aji7",
  y = "FareCardHeader-module_title__XOXYS",
  P = "FareCardHeader-module_subtitle__ZMmDg",
  W = "FareCardHeader-module_with-promos__9h1AV",
  x = "FareCardHeader-module_withEmptyPromos__hFxJh",
  b = "FareCardHeader-module_promos__v3ZvX",
  e = {
    header: F,
    horizontalHeader: z,
    whiteBackground: w,
    neutral01Background: g,
    hilighted: B,
    headerContent: f,
    horizontalHeaderContent: k,
    titleWrapper: N,
    horizontalTitleWrapper: v,
    title: y,
    subtitle: P,
    withPromos: W,
    withEmptyPromos: x,
    promos: b
  },
  T = _ref => {
    let {
      children: _,
      title: u,
      subtitle: l,
      description: i,
      withPromos: n = !1,
      hilighted: s = !1,
      hilightedLabel: h,
      promos: t,
      onPromoBadgeClicked: p,
      backgroundColor: m = "neutral05",
      variant: r = "vertical"
    } = _ref;
    return /* @__PURE__ */o("header", {
      className: d(e.header, {
        [e.hilighted]: s,
        [e.withPromos]: n,
        [e.withEmptyPromos]: !c(t) && r === "vertical",
        [e.horizontalHeader]: r === "horizontal",
        [e.whiteBackground]: m === "white",
        [e.neutral01Background]: m === "neutral01"
      }),
      children: [s && h && /* @__PURE__ */a(C, {
        children: h
      }), n && c(t) && /* @__PURE__ */a(H, {
        promos: t,
        className: e.promos,
        inverted: !0,
        onPromoBadgeClicked: p
      }), /* @__PURE__ */o("div", {
        className: d({
          [e.headerContent]: r === "vertical",
          [e.horizontalHeaderContent]: r === "horizontal"
        }),
        children: [/* @__PURE__ */o("div", {
          className: d(e.titleWrapper, {
            [e.horizontalTitleWrapper]: r === "horizontal"
          }),
          children: [/* @__PURE__ */a("div", {
            className: e.title,
            children: u
          }), l && /* @__PURE__ */a("div", {
            className: e.subtitle,
            children: l
          })]
        }), i && /* @__PURE__ */a("div", {
          className: e.description,
          children: i
        }), _]
      })]
    });
  };
export { T as FareCardHeader };